import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import moment from 'moment';
import { ToastrService } from 'ngx-toastr';
import { BillingInvoiceService } from 'src/app/services/billing-invoice.service';
import { ReferenceLibraryService } from "src/app/services/referenceLibrary.service";
import { acceptedFileTypes } from 'app-models';
@Component({
  selector: 'app-petitioner-invoice-view',
  templateUrl: './petitioner-invoice-view.component.html',
  styleUrls: ['./petitioner-invoice-view.component.scss']
})
export class PetitionerInvoiceViewComponent implements OnInit {
  clientPaymentForm: FormGroup;
  paymentMode: any;
  paymentDate: any;
  referenceNumber: number;
  viewInvoiceData: any;
  attorneysignsrc = "";
  businessLogosrc = "";
  paymentmodeType: any;
  Updatepayment: any;
  uploadedFile: any;
  public payload = new FormData();
  companyLogoImage: any;
  uploadedFiles: any = [];
  cashMode: boolean = false;
  acceptedTypes = acceptedFileTypes;
  constructor(private billinginvoiceservice: BillingInvoiceService,
    private rfelibraryservice: ReferenceLibraryService,
    private router: Router,
    private toaster: ToastrService ,
    private fb: FormBuilder) { }

  ngOnInit(): void {
    this.clientPaymentForm = this.fb.group({
      paymentDate: ['', Validators.required],
      paymentMode:  ['', Validators.required],
      referenceNumber:  ['', Validators.required]
    });
    this.rfelibraryservice
      .getReferencePaymentModeData("PAYMODE")
      .subscribe((res) => {
        this.paymentmodeType = res;
        console.log("mode", this.paymentmodeType);
      });
    this.billinginvoiceservice
      .getPreviewInvoiceDetails(history.state.invoiceId)
      .subscribe((res) => {
        console.log("preview", res);
        this.viewInvoiceData = res;
        this.attorneysignsrc = this.viewInvoiceData.signImage
        ? "data:image/jpeg;base64," + this.viewInvoiceData.signImage
        : null;
        this.businessLogosrc = this.viewInvoiceData.billBycompanyLogo
        ? "data:image/jpeg;base64," + this.viewInvoiceData.billBycompanyLogo
        : null;
        // this.attorneysignsrc = `data:image/jpeg;base64,${this.viewInvoiceData.signImage}`;
        // this.businessLogosrc = `data:image/jpeg;base64,${this.viewInvoiceData.billBycompanyLogo}`;
      });
  }
  cancelpaymentStatus(){
    this.router.navigate(["/petitioner-landing/dashboard/petitioner-dashboard"]);
  }
  sendUpdate(){
    let updatepaymentstatusPayload = {
      invoiceId: history.state.invoiceId,
      modeOfPayment: this.paymentMode,
      paymentDate:  moment(this.clientPaymentForm.get("paymentDate")?.value).format('YYYY-MM-DD'),
      rcvdPayment: 1,
      transactionId: this.referenceNumber,
    };
    this.billinginvoiceservice
    .isclientupdatePaymentInvoice(updatepaymentstatusPayload, history.state.invoiceId, history.state.id)
    .subscribe((res: any) => {
      this.toaster.success(res.message, 'Success');
    
        // this.billinginvoiceservice.uploadproofofPayment(this.payload, history.state.invoiceId).subscribe(res =>{
        //   console.log('proof uploaded');
        // })
        this.router.navigate(["/petitioner-landing/dashboard/petitioner-dashboard"]);
    
   
    });
  }
  UploadproofofPayment(event, fileUpload) {
    fileUpload.clear();
    this.uploadedFile = event.files[0];
    this.uploadedFile["fileName"] = event.files[0].name;
    this.payload = new FormData();
    this.payload.append("file", this.uploadedFile, this.uploadedFile.name);
    this.billinginvoiceservice.uploadproofofPayment(this.payload, history.state.invoiceId).subscribe(res =>{
      this.toaster.success(res.message, 'Success')
      console.log('proof uploaded');
    })
  }
  onUpload(event) {
    for (let file of event.files) {
      this.uploadedFiles.push(file);
      this.payload.append(
        "file",
        this.uploadedFiles,
        this.uploadedFile.fileName
      );
    }
  }
  

  paymentmodeTypechanged(event: any){
    if(event.value =='CASH'){
     this.clientPaymentForm.get("referenceNumber").clearValidators();
     this.clientPaymentForm.get("referenceNumber").updateValueAndValidity();
    //  this.clientPaymentForm.set('referenceNumber').value = "";
     this.clientPaymentForm.patchValue({ referenceNumber: ''});
      this.cashMode = true;
     
     } else{
      this.cashMode = false;
     this.clientPaymentForm.get("referenceNumber").setValidators([Validators.required]);
     this.clientPaymentForm.get("referenceNumber").updateValueAndValidity();
     }
    }

}
